@if (contact) {
  <div class="grid-container margin-top">
    <h2>{{ contactFullName }}</h2>
    <div class="grid-x grid-margin-x grid-margin-y">
      <div class="cell medium-4">
        <div class="bold">First Name:</div>
        {{ contact.firstName }}
      </div>
      <div class="cell medium-4">
        <div class="bold">Middle Initial:</div>
        {{ contact.middleInitial }}
      </div>
      <div class="cell medium-4">
        <div class="bold">Last name:</div>
        {{ contact.lastName }}
      </div>
      <div class="cell medium-4">
        <div class="bold">Display name:</div>
        {{ contact.displayName }}
      </div>
      <div class="cell medium-4">
        <div class="bold">Email:</div>
        {{ contact.emailAddress }}
      </div>
      <div class="cell medium-4">
        <div class="bold">Primary Phone:</div>
        {{ contact.primaryPhone }}
      </div>
      <div class="cell medium-3 flex-align-center">
        <ng-container>
          <label class="vertical-align-middle minor-margin-right"  for="isUser">Is User:</label>
          <input [attr.disabled]="'disabled'" class="no-margin-bottom vertical-align-middle" id="isUser" type="checkbox" [(ngModel)]="contact.isUser">
        </ng-container>
      </div>
      <div class="cell medium-3 flex-align-center">
        <ng-container>
          <label class="vertical-align-middle minor-margin-right" for="canLogIn">Account is Disabled:</label>
          <input [attr.disabled]="'disabled'" class="no-margin-bottom vertical-align-middle" id="canLogIn" type="checkbox" [ngModel]="!contact.canLogIn" (ngModelChange)="contact.canLogIn = $event">
        </ng-container>
      </div>
    </div>
    @if (!contact.internalContact) {
      <div class="grid-x grid-margin-x"  >
        <div class="cell small-12">
          <fieldset class="margin-bottom">
            <legend class="no-margin">Agent Type:</legend>
            <div class="grid-x">
              @for (agent of agentTypes; track agent) {
                <div [ngClass]="agentCellClass">
                  <div class="checkbox">
                    <input class="show-for-sr no-margin vertical-align-middle" type="checkbox" [attr.id]="agent.text" [attr.disabled]="'disabled'" [checked]="userHasRole(agent.id)" />
                    <label [for]="agent.text" class="minor-margin-right display-inline-block">
                      <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>  {{agent.text}}
                    </label>
                  </div>
                </div>
              }
            </div>
          </fieldset>
        </div>
      </div>
    }
    @if (isCurrentlyPrimaryContact()) {
      Each Entity must have a Primary Contact.  You must add an additional Primary Contact or modify an existing agent with a different authority type to be Primary Contact before deleting <b>{{ contactFullName }}</b> as Primary Contact.
      If attempting to remove the Primary Agent and no other agent has executive authority, please click on the Registration button below to begin the re-registration process to provide an Affidavit, along with the reason for deactivating Primary Contact / Agent.
    }
    @if (isCurrentlySoleExecutiveAuthorityContact()) {
      Each Entity must have an Executive Authority.  You must add an additional Executive Authority or modify an existing agent with a different authority type to be Executive Authority before deleting <b>{{ contactFullName }}</b> as Authorized Agent.
    }
    @if (isCurrentlyRequiredAndSoleStatutoryAgentContact()) {
      Each {{ orgType }} must have a Statutory Agent.  You must add an additional Statutory Agent or modify an existing agent with a different authority type to be Statutory Agent before deleting <b>{{ contactFullName }}</b> as Statutory Agent.
    }
    @if (isCurrentlyRequiredAndSoleStatutoryAgentContact() || isCurrentlyPrimaryContact() || isCurrentlySoleExecutiveAuthorityContact()) {
      <br />
      Would you like to make one of the contacts below the {{agentTypeToElevate}}?
      <ag-grid-angular class="data-grid  full-page" [gridOptions]="gridOptions" [rowData]="contacts" aria-label="Contact Deletion"></ag-grid-angular>
      <div >
        <button class="button" (click)="addContact()" aria-label="Add Contact">{{addContactButtonName}}</button>
      </div>
    }
    @if (!isCurrentlyRequiredAndSoleStatutoryAgentContact() && !isCurrentlyPrimaryContact() && !isCurrentlySoleExecutiveAuthorityContact()) {
      Are you sure you want to delete <b>{{contact.firstName}}  {{ contact.lastName }}</b>?
      <div >
        <button class="button" (click)="deleteContact()" aria-label="Yes">Yes</button>
        <button class="button margin-left" (click)="cancel()" aria-label="Cancel">Cancel</button>
      </div>
    }
  </div>
}